module.exports = __webpack_public_path__ + "../resources/images/illustration_to_me-8a66ec42b524b837fe20c280f23efddc.svg";